import { prefersReducedMotion } from '~/utils/storefrontExperience'
import { resolveMediaUrl } from '~/utils/mediaUrl'

const FLY_DURATION_MS = 700

export function useFlyToCart() {
  const { storefrontFlyToCart } = useSiteSettings()
  const config = useRuntimeConfig()

  function flyToCart(input?: { from?: HTMLElement | null, imageUrl?: string | null }): number {
    if (!import.meta.client) return 0
    if (!storefrontFlyToCart.value || prefersReducedMotion()) return 0

    const cart = document.querySelector('[data-cart-target]') as HTMLElement | null
    if (!cart) return 0

    const sourceImg = input?.from?.querySelector?.('img') as HTMLImageElement | null
    const rawSrc = sourceImg?.currentSrc || sourceImg?.src || input?.imageUrl || ''
    const src = resolveMediaUrl(rawSrc, String(config.public.apiOrigin || ''))
    if (!src || src.endsWith('placeholder-product.jpg')) return 0

    const dest = cart.getBoundingClientRect()
    const start = input?.from?.getBoundingClientRect()
      || sourceImg?.getBoundingClientRect()
    if (!start || start.width < 8 || dest.width < 8) return 0

    const flyer = document.createElement('img')
    flyer.src = src
    flyer.alt = ''
    flyer.setAttribute('aria-hidden', 'true')
    Object.assign(flyer.style, {
      position: 'fixed',
      left: `${start.left}px`,
      top: `${start.top}px`,
      width: `${start.width}px`,
      height: `${start.height}px`,
      objectFit: 'contain',
      zIndex: '9999',
      pointerEvents: 'none',
      borderRadius: '14px',
      boxShadow: '0 12px 28px rgba(15, 23, 42, 0.22)',
      transition: `transform ${FLY_DURATION_MS}ms cubic-bezier(0.22, 1, 0.36, 1), opacity ${FLY_DURATION_MS}ms ease`,
      willChange: 'transform, opacity',
    })
    document.body.appendChild(flyer)

    const destX = dest.left + dest.width / 2 - start.width / 2
    const destY = dest.top + dest.height / 2 - start.height / 2
    requestAnimationFrame(() => {
      flyer.style.transform = `translate(${destX - start.left}px, ${destY - start.top}px) scale(0.16)`
      flyer.style.opacity = '0.2'
    })

    const cleanup = () => flyer.remove()
    flyer.addEventListener('transitionend', cleanup, { once: true })
    window.setTimeout(cleanup, FLY_DURATION_MS + 120)
    return FLY_DURATION_MS
  }

  return { flyToCart }
}
